/** A5 yatay (210×148 mm) — eski / alternatif */
export const A5_LANDSCAPE_PAGE_STYLE = `
  @page {
    size: A5 landscape;
    margin: 4mm;
  }
  @media print {
    html, body {
      height: auto !important;
      overflow: visible !important;
    }
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;

/** A5 dikey (148×210 mm) yazdırma — Trendyol / Hepsiburada kargo etiketi */
export const A5_PORTRAIT_PAGE_STYLE = `
  @page {
    size: A5 portrait;
    margin: 5mm;
  }
  @media print {
    html, body {
      height: auto !important;
      overflow: visible !important;
    }
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;

/** Önizleme genişliği — A5 yatay oranına yakın */
export const A5_LANDSCAPE_PREVIEW_MAX_WIDTH = 560;

/** Önizleme genişliği — A5 dikey oranına yakın */
export const A5_PORTRAIT_PREVIEW_MAX_WIDTH = 420;

/** Yazdırma alanı genişliği (4mm kenar boşluğu düşülmüş) */
export const A5_LANDSCAPE_PRINT_WIDTH = '202mm';

/** A5 dikey içerik genişliği — html2canvas / PDF yakalama (138mm ≈ 522px @96dpi) */
export const A5_PORTRAIT_CAPTURE_WIDTH_PX = 522;

/** Yazdırma alanı genişliği — A5 dikey (5mm kenar boşluğu düşülmüş) */
export const A5_PORTRAIT_PRINT_WIDTH = '138mm';

export const a5LandscapePrintSx = {
  '@media print': {
    width: A5_LANDSCAPE_PRINT_WIDTH,
    maxWidth: A5_LANDSCAPE_PRINT_WIDTH,
    minHeight: 'auto',
    boxSizing: 'border-box',
    mx: 'auto',
    p: '0 !important',
    m: '0 auto !important',
    bgcolor: '#fff !important',
    color: '#000 !important',
    boxShadow: 'none !important',
    '@page': {
      size: 'A5 landscape',
      margin: '4mm',
    },
  },
};

export const a5PortraitPrintSx = {
  '@media print': {
    width: A5_PORTRAIT_PRINT_WIDTH,
    maxWidth: A5_PORTRAIT_PRINT_WIDTH,
    minHeight: 'auto',
    boxSizing: 'border-box',
    mx: 'auto',
    p: '0 !important',
    m: '0 auto !important',
    bgcolor: '#fff !important',
    color: '#000 !important',
    boxShadow: 'none !important',
    '@page': {
      size: 'A5 portrait',
      margin: '5mm',
    },
  },
};
